import { Box, Flex, Group, Skeleton, Stack } from '@mantine/core'

export const AnalystRatingsFallback = () => {
  return (
    <Box
      mt={80}
      style={{
        borderRadius: 12,
        width: '100%',
      }}
    >
      <Skeleton
        h={32}
        w={264}
        radius={40}
        mb={12}
        style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 40 }}
      />
      <Flex
        direction={{ base: 'column', medium: 'row' }}
        gap={{ base: 0, medium: 48 }}
        align={'flex-start'}
      >
        <Flex gap={16} py={16}>
          <Skeleton
            h={72}
            w={72}
            style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 1600 }}
          />
          <Stack gap={20}>
            {[0, 1, 2].map(index => (
              <Group gap={8} key={index}>
                <Skeleton
                  h={8}
                  w={{ base: 175, medium: 249 }}
                  style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 24 }}
                />
                <Skeleton
                  h={8}
                  w={64}
                  style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 24 }}
                />
              </Group>
            ))}
          </Stack>
        </Flex>
        <Flex py={12} gap={16}>
          {[0, 1].map(index => (
            <Box key={index}>
              <Skeleton
                h={36}
                w={{ base: 116, medium: 125 }}
                style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 24 }}
              />
            </Box>
          ))}
        </Flex>
      </Flex>
    </Box>
  )
}
